export const JANUARY_OF_CURRENT_YEAR = new Date(new Date().getFullYear(), 0);
export const DECEMBER_OF_CURRENT_YEAR = new Date(new Date().getFullYear(), 11);

export const JANUARY_OF_PREVIOUS_YEAR = new Date(
  new Date().getFullYear() - 1,
  0
);
export const DECEMBER_OF_PREVIOUS_YEAR = new Date(
  new Date().getFullYear() - 1,
  11
);
